import styled, { css } from 'styled-components';
import { depthVariant, radiusVariant, paperTheme } from './theme';
import { PaperProps } from './PaperProps';

/**
 * Basic surface with radius and shadow defined by design system.
 * It should be used to create menu/popover surfaces and much more.
 */
export const Paper = styled.div.attrs<PaperProps>((props ) => ({
  'data-test': props['data-test'] ?? 'paper',
  'data-test-specifier': props['data-test-specifier'],
}))<PaperProps>`
  background-color: ${paperTheme.background};
  box-shadow: ${depthVariant((variant) => variant.shadow)};
  border-radius: ${radiusVariant((variant) => variant.radius)};
  ${({ isPadded }) =>
    isPadded &&
    css`
      padding: ${radiusVariant((variant) => variant.padding)};
    `}
`;
